const aboutUs = {
	title: "Lockie",
	paragraphs: [""],
	showHomePageContact: true,
	joinUs: true
};

export default aboutUs;
